import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-progress',
    templateUrl: './progress.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProgressComponent implements OnInit {
  @Input() value?: number;

  constructor() {}

  ngOnInit() {}
}
